@if(wizardStore.F().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-textarea
      [label]="translationKey + 'mainRights'"
      inputFormControlName="mainRights"
      [inputFormControl]="formGroup.controls.mainRights"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'restrictions'"
      inputFormControlName="restrictions"
      [inputFormControl]="formGroup.controls.restrictions"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'descriptionOfRestriction'"
      inputFormControlName="descriptionOfRestriction"
      [inputFormControl]="formGroup.controls.descriptionOfRestriction"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'exitOptions'"
      inputFormControlName="exitOptions"
      [inputFormControl]="formGroup.controls.exitOptions"
      [rows]="10"
      [maxLength]="2000"
    />
    <app-validated-textarea
      [label]="translationKey + 'equityInstruments'"
      inputFormControlName="equityInstruments"
      [inputFormControl]="formGroup.controls.equityInstruments"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
